module.exports = __webpack_public_path__ + "img/pantalla-6-1-2.448bfc08.png";